import script from "./CollectionDelivery.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionDelivery.vue?vue&type=script&setup=true&lang=js"

import "./CollectionDelivery.vue?vue&type=style&index=0&id=6134d1dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6134d1dc"]])

export default __exports__